/**
 * SAAS服务接口
 * sj:2021年3月8日15:36:33
 **/
import { Injectable } from '@angular/core';
import { SwHttpClientService } from 'src/app/librarys/serves/sw-http-client.service';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ServiceManageService {
   //基础平台微服务api
   prefix: string = environment.seekerWebAPI;


   constructor(
     private http: SwHttpClientService
   ) {
   }

  //#region scheduleTask 服务设置接口


  /**
   * 查询服务列表
   * @param param
   * @returns {Observable<any>}
   */
   queryServicePageList(param) {
    const url = this.prefix + 'product/queryServicePageList';
    return this.http.Post(url, param);
  }

  /**
   * 添加服务
   *
   * @param param
   */
   saveService(param) {
    const url = this.prefix + 'product/saveService';
    return this.http.Post(url, param);
  }
  
    /**
   * 服务上下架
   *
   * @param param
   */
     updateServiceStatus(param) {
      const url = this.prefix + 'product/updateServiceStatus'+param;
      return this.http.Get(url);
    }
  
  //#endregion

}
